import $ from 'jquery';

/**
 * @param {number | string} price
 * @param {{
 * withPP?: boolean
 * }} [params]
 * @returns {string}
 */
function formatPrice(price, {withPP = false} = {}) {
	/* eslint-disable-next-line no-undef */ // todo booking remove dictionary usages
	const {'price_with_currency': template, 'price_thousands_separator': separator} = dictionary,
	      amount         = String(Math.ceil(price)),
	      // Only sites that set a separator group thousands (dk: 28816 -> 28.816).
	      grouped        = separator ? amount.replaceAll(/\B(?=(?:\d{3})+(?!\d))/gu, separator) : amount,
	      formattedPrice = template.replace(':price:', grouped);
	
	return withPP
			? `${formattedPrice} ${dictionary.pricePerPerson}` /* eslint-disable-line no-undef */ // todo booking remove dictionary usages
			: formattedPrice;
}

function getDynamicValue(str, params) {
	let result = str;

	$.each(params, (key, value) => {
		result = result.replace(new RegExp(`%${key}%`), value);
	});

	return result;
}

function getDevType() {
	const innerWidth 	= $(window).innerWidth(),
		  maxMobile 	= 600,
		  maxTablet 	= 1024;

	if (innerWidth <= maxMobile) {
		return 'mobile';
	}

	if (innerWidth > maxMobile && innerWidth < maxTablet) {
		return 'tablet';
	}

	return 'desktop';
}

/**
 * Returns the same values as jQuery's offset method but faster
 * @param {Element} element
 * @returns {{top: number, left: number}}
 */
function getOffset(element) {
	const rect = element.getBoundingClientRect();

	return {
		get 'top'() {
			return rect.top + document.documentElement.scrollTop;
		},
		get 'left'() {
			return rect.left + document.documentElement.scrollLeft;
		}
	};
}

function unique(arr) {
	return arr.filter((value, index) => arr.indexOf(value) === index);
}

export {
	formatPrice,
	getDynamicValue,
	getDevType,
	getOffset,
	unique
};